import { setUnlockPlanModalOpen } from "../../../reducers/ownApp";
import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import { Typography } from "@mui/material";

import { unlockPlanModalOpenSelector } from "../../../reducers/ownApp/selectors";
import {
  fetchDepotRouteMatrix,
  unlockPlan,
} from "../../../reducers/matrixProfile/thunkActions";
import {
  getMatrixProfileType,
  getSelectedMatrixProfile,
  isDailyPlanSelector,
  matrixProfileLockSelector,
} from "../../../reducers/matrixProfile/selectors";

import { Modal } from "../Modal";
import { UnlockPlanModalActions } from "./UnlockPlanModalActions";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

const UnlockPlanModal = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const unlockModalOpen = useSelector(unlockPlanModalOpenSelector);
  const isDaily = useSelector(isDailyPlanSelector);
  const planType = useSelector(getMatrixProfileType);
  const profile = useSelector(getSelectedMatrixProfile);
  const matrixProfileLock = useSelector(matrixProfileLockSelector);

  const closeClick = () => {
    dispatch(setUnlockPlanModalOpen(false));
  };

  const continueCLick = async () => {
    dispatch(setUnlockPlanModalOpen(false));
    const { error } = await dispatch(unlockPlan({ forceUnlock: true }));
    if (error) throw error;
    await dispatch(fetchDepotRouteMatrix({ type: planType, profile }));
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={unlockModalOpen}
        onClose={closeClick}
        title={"Unlock Plan"}
        content={
          <>
            <Typography className={classes.text}>
              Are you sure you wish to unlock this plan?{" "}
            </Typography>
            {matrixProfileLock.lockedByUserName && (
              <Typography className={classes.text}>
                {matrixProfileLock.lockedByUserName} has made changes to some
                routes and will lose these changes if you continue.
              </Typography>
            )}
            {isDaily && (
              <Typography className={classes.text}>
                This will unlock all routes and days on the selected plan.
              </Typography>
            )}
          </>
        }
        actions={
          <UnlockPlanModalActions
            onCancel={closeClick}
            onContinue={continueCLick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default UnlockPlanModal;
